<template>
  <div class="krs028">
    <div class="tb-list_ty2">
      <div class="tb-header">
        <div class="top clear">
          <div class="fl">
            <div class="tb_num"
                 v-html="$i18nUtil.trans('message.SharAndCfrcMemberManage.001','관리자 멤버 수 {cnt}',{cnt:cogroupUserList.length})">
            </div>
            <div class="check_result" v-if="isFilter">
              <div class="txt"
                   v-html="$i18nUtil.trans('search.000.result','{search} 검색 결과 총 {cnt}건',{search:searchKeyword,cnt:cogroupFilterUserList.length})">
              </div>
              <button type="button" v-if="$i18nUtil.getLanguage() === 'ko'" @click="searchReset">{{$i18nUtil.trans("search.040","초기화")}}</button>
            </div>
          </div>

          <div class="tb_sort fr">
            <button type="button" class="btn_link_add" @click="addManager">
              {{$i18nUtil.trans("message.SharAndCfrcAddManager.001","관리자 추가")}}
            </button>
          </div>
        </div>
        <div class="btm clear">
          <div class="fl"></div>
            {{$i18nUtil.trans("message.SharAndCfrcMemberManage.002","선택 관리자를")}}
          <button
            type="button"
            class="btn-primary-small black"
            @click="rejectMember"
          >
            {{$i18nUtil.trans("button.delete.002","제거")}}
          </button>

          <div class="tb_sort fr">
            <div class="dropdown ty2 relative">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" class="disabled">{{
                    searchType == "NAME"
                      ? $i18nUtil.trans("entity.user.name","이름")
                      : searchType == "ID"
                      ? $i18nUtil.trans("entity.user.userId","아이디")
                      : $i18nUtil.trans("entity.user.affiliation","소속")
                  }}</v-btn>
                </template>
                <div class="dropdown-list">
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: searchType == 'NAME' }"
                        @click="searchType = 'NAME'"
                      >
                        {{$i18nUtil.trans("entity.user.name","이름")}}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: searchType == 'ID' }"
                        @click="searchType = 'ID'"
                      >
                        {{$i18nUtil.trans("entity.user.userId","아이디")}}
                      </button>
                    </div>
                  </div>
                  <div class="dropdown-list-item">
                    <div class="tit">
                      <button
                        type="button"
                        :class="{ active: searchType == 'DEPT' }"
                        @click="searchType = 'DEPT'"
                      >
                        {{$i18nUtil.trans("entity.user.affiliation","소속")}}
                      </button>
                    </div>
                  </div>
                </div>
              </v-menu>
            </div>
            <form action="" onsubmit="return false;">
              <div class="search_ty1">
                <input
                  type="text"
                  maxlength="20"
                  class="ico_search"
                  @focus="$event.target.placeholder = ''"
                  @focusout="$event.target.placeholder = $i18nUtil.trans('message.placeholder.keyword','검색어 입력')"
                  :placeholder="$i18nUtil.trans('message.placeholder.keyword','검색어 입력')"
                  @input="searchInput"
                  :value="keyWord"
                  @keyup.enter="handlerFilterMember(searchType, keyWord)"
                />
                <button
                  type="reset"
                  class="input-txt-del"
                  @click="keyWord = ''"
                  v-if="keyWord != ''"
                >
                  {{$i18nUtil.trans("button.delete","삭제")}}
                </button>
                <button
                  type="button"
                  class="btn_search"
                  @click="handlerFilterMember(filter, searchType, keyWord, 1)"
                >
                  {{$i18nUtil.trans("search.039","검색")}}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- //tb-header -->

      <v-data-table
        v-model="checkUsers"
        :headers="headers"
        :items="cogroupFilterUserList"
        :single-select="singleSelect"
        show-select
        :sort-by="'joinDate'"
        :sort-desc="true"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
        class="tb-contents"
      >
        <!-- <template v-slot:item.id="{ item }">
          <div class="ell-singleline">{{ item }}</div>
        </template> -->
        <template v-slot:[`item.userId`]="{ item }">
          <div class="ell-singleline">{{ item.userId }}</div>
        </template>
        <template v-slot:[`item.userName`]="{ item }">
          <div class="droplayer tooltipmember relative">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on"
                  ><b>{{ item.resultName }}</b></v-btn
                >
              </template>
              <div class="dropdown-list">
                <UserTooltip :userId="item.userId" />
              </div>
            </v-menu>
          </div>
        </template>
        <template v-slot:[`item.deptName`]="{ item }">
          <div class="ell-singleline">{{ item.deptName }}</div>
        </template>

        <template v-slot:[`item.jobPositionName`]="{ item }">
          <div class="ell-singleline">{{ item.jobPositionName }}</div>
        </template>

        <template v-slot:[`item.jobFunctionName`]="{ item }">
          <div class="ell-singleline">{{ item.jobFunctionName }}</div>
        </template>

        <template v-slot:[`item.userGrade`]="{ item }">
          <div class="ell-singleline">
            {{ item.userGrade == "MANAGER" ? $i18nUtil.trans("message.ProjectMemberManage.002.manager","운영자") : $i18nUtil.trans("message.ProjectMemberManage.002.member","멤버") }}
          </div>
        </template>
        <template slot="no-data">
          <div class="nodata-txt-noicon">
            <v-alert :value="true"> {{$i18nUtil.trans("search.007","조회된 결과가 없습니다.")}} </v-alert>
          </div>
        </template>
      </v-data-table>

      <div class="pagination">
        <v-pagination
          v-model="page"
          circle
          :length="pageCount"
          :total-visible="7"
        ></v-pagination>
      </div>
    </div>
    <!-- //tb-list_ty1 -->
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import MultiOrg from "@/components/cowork/common/organization/org/MultiOrg";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import EventBus from "@/js/eventbus/eventBus";
import SharAndCfrcAddManager from "./SharAndCfrcAddManager";

export default {
  components: {
    UserTooltip,
    SharAndCfrcAddManager,
  },
  data() {
    return {
      isFilter: false,
      keyWord: "",
      searchKeyword: "",
      searchType: "NAME",
      // memberCount: 0,
      currentGrade: "",
      checkUsers: [],
      cogroupUserList: [],
      cogroupFilterUserList: [],
      error: true,
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      singleSelect: false,
      headers: [
        { text: this.$i18nUtil.trans("entity.user.name","이름"), align: "center", value: "userName", sortable: false },
        { text: this.$i18nUtil.trans("entity.user.userId","아이디"), value: "userId", sortable: false },
        { text: this.$i18nUtil.trans("entity.user.affiliation","소속"), align: "center", value: "deptName", sortable: false },
        {
          text: this.$i18nUtil.trans("entity.user.jobPositionName","직위"),
          align: "center",
          value: "jobPositionName",
          sortable: false,
        },
        {
          text: this.$i18nUtil.trans("entity.user.jobFunctionName","직책"),
          align: "center",
          value: "jobFunctionName",
          sortable: false,
        },
        { text: this.$i18nUtil.trans("entity.user.joinDate","가입일"), align: "center", value: "joinDate", sortable: false },

        { text: this.$i18nUtil.trans("entity.user.permission","권한"), align: "center", value: "userGrade", sortable: false },
      ],
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  created() {
    EventBus.$off("addManager");
    EventBus.$on("addManager", (payload) => {
      this.createdList();
    });
    this.createdList();
  },
  methods: {
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),

    createdList() {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/cogroupUser/getCogroupUserListCosys",
        method: "post",
        params: {
          groupId: this.modalInfo.groupId,
        },
      };
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          obj.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.cogroupUserList = res.result;
            obj.cogroupFilterUserList = res.result;
            obj.checkUsers = [];
          }
        })
        .catch((err) => {
          console.log(err);
          console.log("[그룹멤버 오류]");
        });
    },

    rejectMember() {
      if (this.checkUsers.length == 0) {
        this.toastInfo.message = this.$i18nUtil.trans("message.ProjectMemberManage.007","멤버를 선택해주세요.");
        this.showToast(this.toastInfo);
        return;
      }
      // console.log(this.checkUsers);
      let checkUsers = this.checkUsers;
      let obj = this;
      let deleteCogroupUserList = [];
      checkUsers.forEach((value) => {
        let user = {
          userGrade: "MANAGER",
          userKbn: "01",
          userId: value.userId,
        };
        deleteCogroupUserList.push(user);
      });
      const reqData = {
        url: "/api/cogroup/cogroupUser/deleteCogroupUserCosys",
        method: "post",
        params: {
          groupId: this.modalInfo.groupId,
          deleteCogroupUserList: deleteCogroupUserList,
        },
      };
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)

        .then((res) => {
          obj.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.SharAndCfrcMemberManage.003","관리자가 제거되었습니다.");
            obj.showToast(this.toastInfo);

            obj.createdList();
            obj.searchReset();
          }
        })
        .catch((err) => {
          console.log(err);
          console.log("[권한제거 오류]");
        });
    },
    addManager() {
      const modalInfo = {
        obj: this.$modal,
        component: SharAndCfrcAddManager,
        width: "660px",
        groupId: this.modalInfo.groupId,
      };
      this.showModal(modalInfo);
    },
    handlerFilterMember(searchType, searchKeyword) {
      if (searchKeyword == "") {
        this.toastInfo.message = this.$i18nUtil.trans("TB091");
        this.showToast(this.toastInfo);
        return;
      }
      if (searchKeyword) {
        this.isFilter = true;
        this.searchKeyword = searchKeyword;
        this.cogroupFilterUserList = [];
        this.cogroupUserList.forEach((value) => {
          if (searchType == "NAME") {
            if (value.userName.indexOf(searchKeyword) != -1) {
              this.cogroupFilterUserList.push(value);
            }
          } else if (searchType == "ID") {
            if (value.userId.indexOf(searchKeyword) != -1) {
              this.cogroupFilterUserList.push(value);
            }
          } else {
            if (value.deptName.indexOf(searchKeyword) != -1) {
              this.cogroupFilterUserList.push(value);
            }
          }
        });
      }
    },
    searchInput(e) {
      this.keyWord = event.target.value;
    },
    searchReset() {
      this.isFilter = false;
      this.searchKeyword = "";
      this.keyWord = "";
      this.cogroupFilterUserList = this.cogroupUserList;
    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/SharAndCfrcMemberManage.vue